import React, { memo } from 'react'

import type { NavTabItemProps } from './NavTabItem/NavTabItem'
import NavTabItem from './NavTabItem/NavTabItem'
import { NavTabsContent, StyledNavContainer, StyledNavTabs } from './NavTabs.styles'

export interface NavTabsProps {
  tabs: NavTabItemProps[]
  onClick?: () => void
}

const NavTabs = ({ tabs, onClick }: NavTabsProps) => (
  <StyledNavTabs>
    <NavTabsContent>
      <StyledNavContainer flex>
        {tabs.map(tab => (
          <NavTabItem key={tab.title} {...tab} onClick={onClick} />
        ))}
      </StyledNavContainer>
    </NavTabsContent>
  </StyledNavTabs>
)

export default memo(NavTabs)
